import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import HugLogoSrc from "components/Logo/Logo.png";

const Footer = () => {
  return (
    <footer>
      <Box>
        <Box display="flex" justifyContent="center" mb={2} mt={8}>
          <img
            src={HugLogoSrc}
            height={30}
            alt="HiddenUnderGround logo"
          />
        </Box>
        <Box display="flex" justifyContent="center" flexWrap="wrap" my={4}>
          {[
            { path: "/", label: "Home" },
            { path: "/help", label: "Help" },
            { path: "/feedback", label: "Feedback" },
            { path: "/privacy", label: "Privacy" },
            { path: "/terms", label: "Terms" },
            { path: "/about", label: "About" },
          ].map((item) => (
            <Typography
              key={item.path}
              sx={{ fontSize: 14, fontWeight: 500, margin: "0 20px" }}
            >
              <NavLink to={item.path} style={{ color: "#444", textDecoration: "none" }}>
                {item.label}
              </NavLink>
            </Typography>
          ))}
        </Box>
        <Box textAlign="center" my={2}>
          <Typography variant="caption" sx={{ fontSize: 14 }}>
            {new Date().getFullYear()} HiddenUnderGround
             <span
              style={{
                fontSize: "1.1em", // bigger
                verticalAlign: "super", // superscript
                marginLeft: "3px", // small space from text
              }}
            >
              ®
            </span>
            All rights reserved
          </Typography>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
